import React, { memo } from 'react';
import TextButtonBasic from './TextButtonBasic';
import TextButtonToolTip from './TextButtonToolTip';

interface TextButtonPropsT {
  tooltip?: string,
  tooltipPlacement?: 'right' | 'bottom-end' | 'bottom-start' | 'bottom' | 'left-end' | 'left-start' | 'left' | 'right-end' | 'right-start' | 'top-end' | 'top-start' | 'top',
  label: string,
  icon?: React.ReactNode,
  onClick?: (e) => void,
  isActive?: boolean,
  isWarning?: boolean,
  isDisabled?: boolean,
  inProcess?: boolean,
  iconRight?: boolean,
  margin?: string,
  fontSize?: number,
  width?: number,
  height?: number,
}

const TextButton = (props: TextButtonPropsT) => {
  if (props?.tooltip)
    return(
      <TextButtonToolTip {...props} />
    )
  return(
    <TextButtonBasic {...props} />
  )
}
export default memo(TextButton);
